//Core modules
import React from "react";

//External modules
import {Button} from "reactstrap";

//Internal modules
import {useStepsContext} from "./context/stepsContext";
import successtick from "../../assets/utils/images/successtick.png";
import {proceeToLink} from "../../Common/Appcommon";

const SubscriptionConfirmation = () => {

    const {
        usageType
    } = useStepsContext();

    let title = `Payment Updated Successfully.`;

    if(usageType === 3 || usageType === 4 || usageType === 7){
        title = `Subscription updated successfully.`;
    } else if( usageType === 2 || usageType === 5  || usageType === 6) {
        title = `Subscription authorized successfully.`;
    }

    return(
        <>
            <div className="Payment-confirm">
                <div className="Payment-confirm">
                    <img src={successtick} className="Payment-confirm-image"></img>
                </div>

                <div className="Payment-confirm-list">
                    <span className="subscription-title Payment-confirm-text ">
                        {title}
                    </span>
                </div>

                <div className="Payment-confirm-list hide">
                    <p className="payment-infos">
                        Transtion ID :
                    </p>
                </div>

                <div>
                    <p className="payment-infos hide">
                        Order ID
                    </p>
                </div>

                <div className="Payment-confirm">
                    <Button onClick={()=>proceeToLink(`/#/settings/account/subscription`, false)} className="m-1 me-2 btn-icon le-button lePrimaryBtn btn btn-success">
                        Show Details
                    </Button>
                </div>
            </div>
        </>
    )
}

export default SubscriptionConfirmation;